import { render, staticRenderFns } from "./EditBusinessInfo.vue?vue&type=template&id=18f22959"
import script from "./EditBusinessInfo.vue?vue&type=script&lang=js"
export * from "./EditBusinessInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports